(function() {

  // ================================
  // FADE + SLIDE UP ON SCROLL
  // ================================
  const style = document.createElement('style');
  style.textContent = `
    .nlx-reveal {
      opacity: 0;
      transform: translateY(40px);
      transition: opacity 0.7s ease, transform 0.7s ease;
    }

    .nlx-reveal.visible {
      opacity: 1;
      transform: translateY(0);
    }

    .nlx-reveal-delay-1 { transition-delay: 0.1s; }
    .nlx-reveal-delay-2 { transition-delay: 0.2s; }
    .nlx-reveal-delay-3 { transition-delay: 0.3s; }
    .nlx-reveal-delay-4 { transition-delay: 0.4s; }

    .nlx-icon-pulse {
      animation: none;
    }

    .nlx-icon-pulse.pulse {
      animation: nlx-pulse 0.6s ease-out;
    }

    @keyframes nlx-pulse {
      0%   { transform: scale(1); }
      40%  { transform: scale(1.25); filter: drop-shadow(0 0 16px rgba(168, 85, 247, 0.9)); }
      70%  { transform: scale(0.95); }
      100% { transform: scale(1); filter: drop-shadow(0 0 8px rgba(168, 85, 247, 0.4)); }
    }
  `;
  document.head.appendChild(style);

  // Add reveal class to sections
  const revealTargets = [
    '.nlx-services-inner',
    '.nlx-products-header',
    '.nlx-about-inner',
    '.nlx-about-stats',
    '.nlx-cta-content',
    '.nlx-view-all',
  ];

  revealTargets.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.classList.add('nlx-reveal');
    });
  });

  // Add staggered delays to product cards
  document.querySelectorAll('.nlx-product-card').forEach((card, i) => {
    card.classList.add('nlx-reveal');
    card.classList.add(`nlx-reveal-delay-${Math.min(i + 1, 4)}`);
  });

  // Add staggered delays to service items
  document.querySelectorAll('.nlx-service-item').forEach((item, i) => {
    item.classList.add('nlx-reveal');
    item.classList.add(`nlx-reveal-delay-${i + 1}`);
  });

  // Add staggered delays to stats
  document.querySelectorAll('.nlx-stat').forEach((stat, i) => {
    stat.classList.add('nlx-reveal');
    stat.classList.add(`nlx-reveal-delay-${i + 1}`);
  });

  // Add pulse class to service icons
  document.querySelectorAll('.nlx-service-icon svg').forEach(icon => {
    icon.classList.add('nlx-icon-pulse');
  });

  // ================================
  // INTERSECTION OBSERVER
  // ================================
 const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      } else {
        entry.target.classList.remove('visible');
      }
    });
  }, { threshold: 0.25 });

  document.querySelectorAll('.nlx-reveal').forEach(el => {
    observer.observe(el);
  });

  // Icon pulse observer
 const iconObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.remove('pulse');
        setTimeout(() => {
          entry.target.classList.add('pulse');
        }, 300);
      } else {
        entry.target.classList.remove('pulse');
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.nlx-icon-pulse').forEach(el => {
    iconObserver.observe(el);
  });

  // ================================
  // STATS COUNT UP
  // ================================
  function countUp(el, target, duration) {
    // Handle non-numeric stats like 'FL' and '∞'
    if (isNaN(parseInt(target))) return;

    const isPercent = target.includes('%');
    const num = parseInt(target);
    const start = performance.now();

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(eased * num);
      el.textContent = current + (isPercent ? '%' : '');
      if (progress < 1) requestAnimationFrame(update);
      else el.textContent = target;
    }

    requestAnimationFrame(update);
  }

  const statsObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const numberEl = entry.target.querySelector('.nlx-stat-number');
        if (numberEl) {
          const original = numberEl.textContent.trim();
          countUp(numberEl, original, 4000);
        }
        statsObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('.nlx-stat').forEach(el => {
    statsObserver.observe(el);
  });

})();
